import { render, staticRenderFns } from "./AdminMarketPopups.vue?vue&type=template&id=fbc512ac"
import script from "./AdminMarketPopups.vue?vue&type=script&lang=js"
export * from "./AdminMarketPopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports